import { render } from "./agenda-navbar-switch.vue?vue&type=template&id=5e31ed1e"
import script from "./agenda-navbar-switch.vue?vue&type=script&lang=js"
export * from "./agenda-navbar-switch.vue?vue&type=script&lang=js"
script.render = render

export default script